import React, { useEffect, useState, useContext } from 'react';
import './Components.css';
import { AppContext, ViewOnlyContext, ThemeContext } from '../contexts/AppContext';
import { session_update, process_toptracer_shots } from '../mobile/mobileHandler';
import { SetCurrentSession, PullTemplate,ResetSessions, ExportCurrentSession, ExportCurrentSessionMultiple, HasMultipleSessions, GetCurrentSession, FinalizeSession, CloneSession, LoadSession, ResetTaskSessions } from '../isdlData/sessionData';
import { GetUser } from '../isdlData/matrixUserData';
import { Modal } from '@mui/material';
import ResetSession from './ResetSession';
import FinalizeSessionModal from './FinalizeSessionModal';
import CloneSessionModal from './CloneSessionModal';
import ResetTaskModal from './ResetTaskModal';
import packageJson from '../../package.json';
import {Cross2Icon} from './../icons/Icons';
import { convertAppVersionToReadable, isValidTaskId } from '../utils/Utilities';
import { GetCSVTemplate, getTemplateSelectionCookieData, clearTemplateSelectionCookie } from './export/csv';
import { useAppStateService } from '../contexts/AppState';
import { exportUserPreferences, importUserPreferences, USER_PREFERENCES_IMPORTED_EVENT } from '../utils/userPreferences';

function Settings({setFlyoutState, onLoadSession, drawerOpenState, onLoadModal}){

    const [resetSessionOpen, setResetSessionOpen] = useState(false);
    const [finalizeSessionOpen, setFinalizeSessionOpen] = useState(false);
    const [finalizedButtonDisabled, setFinalizedButtonDisabled] = useState(false);
    const [cloneSessionOpen, setCloneSessionOpen] = useState(false);
    const [resetTaskOpen, setResetTaskOpen] = useState(false);
    const [resetTaskWorking, setResetTaskWorking] = useState(false);
    const [showMultiButton, setShowMultiButton] = useState(false);
    const [templateState, setTemplateState] = useState({ loaded: false, savedAt: null, fileName: "" });

    const appState = useAppStateService();
    const { viewOnly } = useContext(ViewOnlyContext);
    const { theme, setAppTheme } = useContext(ThemeContext);

    useEffect(() => {
        const loadSync = async () => {
            setShowMultiButton(await HasMultipleSessions());
            finalizeButtonState();
        };
        loadSync();
    },[]);

    useEffect(() => {
        const templateData = getTemplateSelectionCookieData();
        if(templateData){
            setTemplateState({ loaded: true, savedAt: templateData.savedAt, fileName: templateData.fileName || "" });
        }
    }, []);

    useEffect(() => {
        const handleImportedPreferences = () => {
            const templateData = getTemplateSelectionCookieData();
            if(templateData){
                setTemplateState({ loaded: true, savedAt: templateData.savedAt, fileName: templateData.fileName || "" });
                return;
            }

            setTemplateState({ loaded: false, savedAt: null, fileName: "" });
        };

        window.addEventListener(USER_PREFERENCES_IMPORTED_EVENT, handleImportedPreferences);
        return () => {
            window.removeEventListener(USER_PREFERENCES_IMPORTED_EVENT, handleImportedPreferences);
        };
    }, []);

    const newSessionClick = () => {
        setResetSessionOpen(true);
    };

    function newSession(value){
        if(value){
            if(setFlyoutState)
                setFlyoutState(false);
            SetCurrentSession(null);
            ResetSessions();
            onLoadSession(null, "PORTAL");
            session_update('no_session','no_setup');
        }else{
            setResetSessionOpen(false);
        }
    }

    function aboutClick(){
        window.alert("Web Version: " + convertAppVersionToReadable(packageJson.version) + "\nBuild type: " + packageJson.buildType);
    }

    function toggleTheme(){
        setAppTheme(theme === 'dark' ? 'light' : 'dark');
    }

    const ExportCSVSingle = () => {
        ExportCurrentSession();
    }
    
    

    const ExportCSVMultiple = () => {
        ExportCurrentSessionMultiple();
    }

    const handleLoadSession = async () => {
        const user = await GetUser(GetCurrentSession().DataCollectorId);
        // SetCurrentSession(null);
        // ResetSessions();
        onLoadModal(user, "EXISTINGSESSION");
            session_update('no_session','no_setup');
    }

    const handleFinalizeSession = () => {
        setFinalizeSessionOpen(true);
    }

    const handleCloneSession = () => {
        setCloneSessionOpen(true);
    }

    const handleResetTask = () => {
        setResetTaskOpen(true);
    }

    const handleTemplateSelection = async () => {
        if(templateState.loaded){
            clearTemplateSelectionCookie();
            setTemplateState({ loaded: false, savedAt: null, fileName: "" });
            return;
        }

        const templateData = await GetCSVTemplate();
        if(templateData && templateData.templateSelection){
            setTemplateState({ loaded: true, savedAt: templateData.savedAt, fileName: templateData.fileName || "" });
        }
    }

    async function finalizeSessionDone(result){
        if(result){
            await FinalizeSession();
            setFinalizeSessionOpen(false);
            finalizeButtonState();

            //empty session out and go back to start
            ResetSessions();
            onLoadSession(null, "START");
                session_update('no_session','no_setup');
        }else{
            setFinalizeSessionOpen(false);
        }
    }

    const finalizeButtonState = () => {
        if(viewOnly){
            setFinalizedButtonDisabled(true);
            return;
        }

        if(GetCurrentSession().TaskFinished){
            setFinalizedButtonDisabled(true);
            return;
        }

        setFinalizedButtonDisabled(false);
        return;
    }

    const cloneSessionDone = async (results) => {
        if(results.valid){
            let newSession = await CloneSession(GetCurrentSession(), results.data);
            setCloneSessionOpen(false);
            await LoadSession(newSession.id);

            let setupId = '';

            if(newSession.SessionSetups && newSession.SessionSetups.length > 0){
                setupId = newSession.SessionSetups[0].Id;
            }

            const newSessionData = {Type: 'refresh', session_id : newSession.id , setup_id : setupId};

            const event = new CustomEvent('sessionUpdate', { detail: JSON.stringify(newSessionData) });
            window.dispatchEvent(event);//tell Session.js to refresh current open session to new session
            
        }else{
            setCloneSessionOpen(false);
        }
    }

    function CanProcessTopTracerShots(){
        const curSession = GetCurrentSession();
        if(appState.InApp && curSession !== null && curSession.SiteID && curSession.SiteID !== ""){
            return true;
        }
        return false;
    }

    const handleResetTaskConfirm = async () => {
        if(resetTaskWorking){
            return;
        }

        setResetTaskWorking(true);
        try{
            const result = await ResetTaskSessions();
            if(!result || !result.valid || !result.session){
                const reason = result?.reason ? ` (${result.reason})` : '';
                throw new Error(`Unable to reset task${reason}.`);
            }

            const refreshedSession = await LoadSession(result.session.id);
            let setupId = '';

            if(refreshedSession.SessionSetups && refreshedSession.SessionSetups.length > 0){
                setupId = refreshedSession.SessionSetups[0].Id;
            }

            const newSessionData = {Type: 'refresh', session_id : refreshedSession.id , setup_id : setupId};
            const event = new CustomEvent('sessionUpdate', { detail: JSON.stringify(newSessionData) });
            window.dispatchEvent(event);
            setResetTaskOpen(false);
        }catch(e){
            console.error("Reset task failed:", e);
            const event = new CustomEvent('upsertSessionError', { detail: { message: "Reset task failed.\n" + e.message } });
            window.dispatchEvent(event);
        }finally{
            setResetTaskWorking(false);
        }
    }

    const handleResetTaskCancel = () => {
        if(resetTaskWorking){
            return;
        }
        setResetTaskOpen(false);
    }

    const handleProcessTopTracerShots = () => {
        process_toptracer_shots("process");
    }

    const handleDownloadTopTracerShots = () => {
        process_toptracer_shots("download");
    }

    const handleExportPreferences = async () => {
        try{
            await exportUserPreferences();
        }catch(error){
            console.error("Preferences export failed:", error);
            window.dispatchEvent(new CustomEvent('upsertSessionError', { detail: { message: "Preferences export failed.\n" + error.message } }));
        }
    }

    const handleImportPreferences = async () => {
        try{
            const result = await importUserPreferences();
            if(!result?.imported){
                return;
            }

            const importedTheme = localStorage.getItem('theme');
            if(importedTheme === 'light' || importedTheme === 'dark'){
                setAppTheme(importedTheme);
            }
        }catch(error){
            console.error("Preferences import failed:", error);
            window.dispatchEvent(new CustomEvent('upsertSessionError', { detail: { message: "Preferences import failed.\n" + error.message } }));
        }
    }

    return(
        <div className='settings-container'>
            {drawerOpenState && (
                <button style={{width:'40px', height:'40px', marginLeft:'auto', background:'transparent', border:'0px'}} onClick={drawerOpenState(false)}>
                    <Cross2Icon width='40px' height='40px'/>
                </button>
            )}
            
            <h2>FILE</h2>
            {/* <button className='button' style={{marginBottom:"10px", width:'calc(100% - 60px)'}} onClick={() => newSessionClick()}>New Session</button> */}
            <button className='button' style={{marginBottom:"10px", width:'calc(100% - 60px)'}} onClick={() => handleLoadSession()}>Load Session</button>
            <button className='button' style={{marginBottom:"10px", width:'calc(100% - 60px)'}} onClick={() => handleCloneSession()}>Clone Session</button>
            <button className='button' style={{marginBottom:"10px", width:'calc(100% - 60px)'}} onClick={() => handleImportPreferences()}>Import Prefs</button>
            <button className='button' style={{marginBottom:"10px", width:'calc(100% - 60px)'}} onClick={() => handleExportPreferences()}>Export Prefs</button>
            {isValidTaskId(GetCurrentSession()?.TaskID) && (
                <button className='button' style={{marginBottom:"10px", width:'calc(100% - 60px)'}} disabled={resetTaskWorking} onClick={() => handleResetTask()}>Reset Task</button>
            )}
            <div style={{
                        border: "2px solid #333",
                        padding: "12px",
                        borderRadius: "8px",
                        width: "calc(100% - 60px)"
                        }}>
                <button
                    className='button'
                    style={{
                        marginBottom: templateState.loaded ? "6px" : "10px",
                        marginLeft: "0px",
                        width: '100%',
                        backgroundColor: templateState.loaded ? "#ffff44ff" : undefined,
                        color: templateState.loaded ? "#070606ff" : undefined
                    }}
                    onClick={() => handleTemplateSelection()}>
                    {templateState.loaded ? "Clear Template" : "Import Template For Export"}
                </button>
                {templateState.loaded && (
                    <div style={{ marginBottom: "10px", fontSize: "0.85rem" }}>
                        Using {templateState.fileName || "Template"} Loaded: {templateState.savedAt ? new Date(templateState.savedAt).toLocaleString() : ""}
                    </div>
                )}
                <button className='button' style={{marginBottom: "10px",marginLeft:"0px",width:'100%'}} onClick={() => ExportCSVSingle()}>
                    Export Session
                </button>
                <button className='button' style={{marginBottom: "10px",marginLeft:"0px", width:'100%'}} onClick={() => ExportCSVMultiple()} hidden={!showMultiButton}>
                    Export Multiple Sessions
                </button>

                
            </div>
            
            {CanProcessTopTracerShots() && (
                <>
                    <div style={{width:'calc(100% - 60px)', height:'20px'}}/>
                    <button className='button' style={{marginBottom:"10px", width:'calc(100% - 60px)'}} onClick={() => handleProcessTopTracerShots()}>Process Shots</button>
                    <button className='button' style={{marginBottom:"10px", width:'calc(100% - 60px)'}} onClick={() => handleDownloadTopTracerShots()}>Download Shots</button>
                </>
            )}
            <div style={{width:'calc(100% - 60px)', height:'20px'}}/>
            <Modal
                open={resetSessionOpen}>
                    <ResetSession resetSessionResult={newSession}/>
            </Modal>
            <Modal
                open={finalizeSessionOpen}>
                    <FinalizeSessionModal finalizeSessionResult={finalizeSessionDone}/>
            </Modal>
            <Modal
                open={cloneSessionOpen}>
                    <CloneSessionModal cloneSessionResult={cloneSessionDone} currentSession={GetCurrentSession()}/>
            </Modal>
            <Modal
                open={resetTaskOpen}>
                    <ResetTaskModal onConfirm={handleResetTaskConfirm} onCancel={handleResetTaskCancel} taskId={GetCurrentSession()?.TaskID}/>
            </Modal>
        </div>
    );
}

export default Settings;
